import { FC, ReactNode } from 'react'
import { getConfigValue } from '~/helpers/envHelpers'

const DevOnly: FC<{ children: ReactNode }> = ({ children }) => {
  const env = getConfigValue('MODE') || 'development'
  return <>{env === 'development' ? children : null}</>
}

export default DevOnly
